export default {
  type: "v-form",
  attrs: {
    inputContainerAttrs: {
      class: 'px-4 py-1'
    },
    titleAttrs: {},
  }
}
